var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { EnumFilter } from './EnumFilter';
import { filterIsTrue, filterIsFalse } from '../../messages';
/**
 * The BooleanFilter component used for editing boolean value of FilterDescriptor object.
 */
var BooleanFilter = /** @class */ (function (_super) {
    __extends(BooleanFilter, _super);
    function BooleanFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [{ text: filterIsTrue, value: true }, { text: filterIsFalse, value: false }];
        return _this;
    }
    /**
     * @hidden
     */
    BooleanFilter.prototype.render = function () {
        return (React.createElement(EnumFilter, { filter: this.props.filter, onFilterChange: this.props.onFilterChange, data: this.props.data || this.data, defaultItem: this.props.defaultItem }));
    };
    /**
     * @hidden
     */
    BooleanFilter.propTypes = {
        filter: PropTypes.object.isRequired,
        onFilterChange: PropTypes.func.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, value: PropTypes.any })),
        defaultItem: PropTypes.any
    };
    return BooleanFilter;
}(React.Component));
export { BooleanFilter };
//# sourceMappingURL=BooleanFilter.js.map